export default "__VITE_ASSET__17a71706__"